'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var saveButtons = document.querySelectorAll('.common-save-button');

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = saveButtons[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var saveBtn = _step.value;

            if (saveBtn.alreadyRegisteredClick === true) return;

            saveBtn.addEventListener('click', _commonSaverLibrary.commonSaverLibrary.saveCommon);
            saveBtn.alreadyRegisteredClick = true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};

var _commonSaverLibrary = require('../libraries/commonSaverLibrary');


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/Initializers/commonSaver.js
// module id = 409
// module chunks = 0